import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { authApi } from '../api/auth';
import './Auth.css';

const ResetPasswordWithToken: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (password.length < 12) {
      setError('Hasło musi mieć co najmniej 12 znaków');
      return;
    }
    if (password !== confirm) {
      setError('Hasła nie są identyczne');
      return;
    }
    setLoading(true);
    try {
      await authApi.resetPasswordWithToken(token, password);
      setDone(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Link wygasł lub jest nieprawidłowy.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <h1 className="auth-title">Reset hasła</h1>
          <div className="auth-error">Brak tokenu w adresie URL.</div>
          <p className="auth-footer">
            <Link to="/forgot-password">Zażądaj nowego linku</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <form className="auth-card" onSubmit={handleSubmit}>
        <h1 className="auth-title">Ustaw nowe hasło</h1>

        {done ? (
          <>
            <div className="auth-info">
              Hasło zostało zmienione. Za chwilę przekierujemy Cię do logowania.
            </div>
            <p className="auth-footer">
              <Link to="/login">Zaloguj się</Link>
            </p>
          </>
        ) : (
          <>
            {error && <div className="auth-error">{error}</div>}

            <div className="form-group">
              <label className="form-label">Nowe hasło (min. 12 znaków)</label>
              <input
                className="form-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={12}
                autoFocus
              />
            </div>
            <div className="form-group">
              <label className="form-label">Powtórz nowe hasło</label>
              <input
                className="form-input"
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
                minLength={12}
              />
            </div>

            <button className="btn btn-primary auth-btn" type="submit" disabled={loading}>
              {loading ? 'Zapisywanie...' : 'Zapisz nowe hasło'}
            </button>
          </>
        )}
      </form>
    </div>
  );
};

export default ResetPasswordWithToken;
